import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { environment } from '@environments/_current/environment';
import { TenantTheme } from '@skyfit/core-data-library';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminThemeService {
  private readonly http = inject(HttpClient);
  private readonly themeSource = new BehaviorSubject(null);
  theme = signal(undefined);
  theme$ = this.themeSource.asObservable();

  setTheme(theme: TenantTheme): void {
    this.themeSource.next(theme);
  }

  getCurrentTheme(): TenantTheme | null {
    return this.themeSource.getValue();
  }

  uploadImage(formData: FormData, tenantId: string): Observable<TenantTheme> {
    const apiUrl = `${environment.aaptivServiceUrl}/api/v1/admin/enterpriseTenants/${tenantId}/theme/mobileTheme/image`;
    return this.http.post<TenantTheme>(apiUrl, formData);
  }

  getTenantMobileTheme(tenantId: string): Observable<TenantTheme> {
    const apiUrl = `${environment.aaptivServiceUrl}/api/v1/admin/enterpriseTenants/${tenantId}/theme/mobileTheme`;
    return this.http.get<TenantTheme>(apiUrl);
  }

  updateTenantMobileTheme(
    updatedTheme: TenantTheme,
    tenantId: string,
    tenantName: string
  ): Observable<TenantTheme> {
    updatedTheme.name = tenantName + ' mobileTheme';
    const apiUrl = `${environment.aaptivServiceUrl}/api/v1/admin/enterpriseTenants/${tenantId}/theme/mobileTheme`;
    return this.http.put<TenantTheme>(apiUrl, updatedTheme);
  }

  isValidHexColor(color: string): boolean {
    return /^#[0-9A-F]{6}$/i.test(color);
  }
}
